import React, { useEffect } from "react";
import Layout from "./Layout";
import Dashboard from "../components/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../features/authSlice";


const DashboardPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isError } = useSelector((state) => state.auth);

    useEffect(() => {
        dispatch(getMe());
    }, [dispatch]);

    const loggedInUser = localStorage.getItem("login");

    useEffect(() => {
        if (isError) {
            navigate("/");
        }
    }, [isError, navigate]);

    if (loggedInUser) {

        return (
            <Layout>
                <Dashboard />
            </Layout>
        );
    }
};

export default DashboardPage;